import { render } from "./recharge.vue?vue&type=template&id=87c6cdb2&scoped=true&ts=true"
import script from "./recharge.vue?vue&type=script&lang=ts"
export * from "./recharge.vue?vue&type=script&lang=ts"

import "./recharge.vue?vue&type=style&index=0&id=87c6cdb2&lang=stylus&scoped=true"

import exportComponent from "D:\\Front-end-project\\anxin-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87c6cdb2"]])

export default __exports__